import { createAction } from '@reduxjs/toolkit';

import { type IFetchRimmEntityParams } from '../services';

export const getRimmEntity = createAction<IFetchRimmEntityParams>('getRimmEntity');
